import React, { useRef } from 'react'
import Button from '@mui/material/Button';
import emailjs from '@emailjs/browser'

function Contact() {

  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.send("service_3yu0ose", "template_nmj03i7",
      form.current, 'qW9nFsMv3TvvIaCqo')
      .then((result) => {
        console.log(result.text);
    }, (error) => {
        console.log(error.text);
    });
  e.target.reset();
};

return (
  <div className='flex h-[80vh] justify-center items-center'>
    <div className=' flex flex-col justify-center items-evenly bg-[#F7F7F7] w-5/6'>
      <div className='font-extralight text-4xl md:text-6xl flex justify-start  mt-[35px] '>Contact me ! </div>
      <form onSubmit={sendEmail} ref={form}>
        <input type="email" name="email" id="email" className='w-5/6 md:w-3/5 p-2 m-2' placeholder='Enter your Email' />
        <input type="text" name="name" id="name" className='w-5/6 md:w-3/5 p-2 m-2' placeholder='Enter your name' />
        <input type="text" name="subject" id="subject" className='w-5/6 md:w-3/5 p-2 m-2' placeholder='Subject' />
        <textarea name="message" id="message" cols="30" rows="5" className='w-5/6 
      md:w-3/5 p-2 m-2' placeholder='Enter your text'></textarea>
        <div className='w-1/6 m-2'><button 
        className='bg-[#007FFF] p-2 m-2 rounded-lg text-white'
        type='submit' value="Send" >Send</button></div>
      </form>
    </div>
  </div>
)
}

export default Contact
